import { Validators } from '@angular/forms';

export const codeUKTZEDMinLength = 8;
export const codeUKTZEDMaxLength = 10;
export const codeUKTZEDCanadaLength = 10;
export const codeUKTZEDPattern = /^[0-9]{8,10}$/;
export const codeUKTZEDCanadaPattern = /^[0-9]{10}$/;
export const codeUKTZEDMoldovaPattern = /^[0-9]{10}$/;
export const codeUKTZEDCommonValidators = [
  Validators.pattern(codeUKTZEDPattern),
  Validators.required,
];
